export default __webpack_public_path__ + "static/media/logo-h-with-text-light.00a60593.png";